<template>
    <div id="newMenu">
        <div id="mainMenu">
            <div id="marker" :class="getRouteName"></div>
            <div id="slideshow">
                <router-link v-if="store.splashPage == false" :to="{ name: 'detail' }"
                    :class="{ active: routeIsHome }">Slideshow</router-link>
                <span v-else>Slideshow</span>
            </div>
            <div id="index">
                <router-link v-if="store.splashPage == false" :to="{ name: this.store.lastIndex }"
                    :class="{ active: routeIsIndex }">Index</router-link>
                <span v-else>Index</span>
            </div>
            <div id="about">
                <router-link v-if="store.splashPage == false" :to="{ name: this.store.lastAbout }"
                    :class="{ active: routeIsAbout }">About</router-link>
                <span v-else>About</span>
            </div>
        </div>
        <div id="subMenu" v-if="routeIsHome">
            <div id="marker2" :class="store.random ? 'shuffle' : 'linear'"></div>
            <div id="shuffle">
                <span @click="makeRandom" :class="{ active: store.random }">Shuffle</span>
            </div>
            <div id="linear">
                <span @click="makeLinear" :class="{ active: !store.random }">Linear</span>
            </div>
        </div>
        <div id="subMenu" v-else-if="routeIsIndex">
            <div id="marker2" :class="$route.name == 'images' ? 'images' : 'index'"></div>
            <div id="text">
                <router-link :to="{ name: 'index' }" :class="{ active: $route.name == 'index' }">Text</router-link>
            </div>
            <div id="image">
                <router-link :to="{ name: 'images' }" :class="{ active: $route.name == 'images' }">Image</router-link>
            </div>
        </div>
        <div id="subMenu" v-else-if="routeIsAbout">
            <div id="marker2" :class="$route.name == 'studio-image' ? 'images' : 'index'"></div>
            <div id="text">
                <router-link :to="{ name: 'studio' }" :class="{ active: $route.name == 'studio' }">Text</router-link>
            </div>
            <div id="image">
                <router-link :to="{ name: 'studio-image' }"
                    :class="{ active: $route.name == 'studio-image' }">Image</router-link>
            </div>
        </div>
    </div>
</template>

<script>
import { store } from "@/centralStore";

export default {
    name: "NewMenu",
    props: [],
    data() {
        return {
            store: store.state
        };
    },
    computed: {
        getRouteName() {
            if (this.store.splashPage) {
                return "";
            }
            if (this.routeIsHome) {
                return "Slideshow";
            } else if (this.routeIsIndex) {
                return "Index";
            } else if (this.routeIsAbout) {
                return "About";
            }
        },
        routeIsHome() {
            if (
                !this.store.splashPage &&
                (this.$route.name == "detail" ||
                    this.$route.name == "swipe-slug" ||
                    this.$route.name == "swipe-image" ||
                    this.$route.name == "swipe" ||
                    this.$route.name == "detail-slug" ||
                    this.$route.name == "detail-image")
            ) {
                return true;
            } else {
                return false;
            }
        },
        routeIsIndex() {
            if (
                !this.store.splashPage &&
                (this.$route.name == "index" || this.$route.name == "images")
            ) {
                return true;
            } else {
                return false;
            }
        },
        routeIsAbout() {
            if (
                !this.store.splashPage &&
                (this.$route.name == "studio" ||
                    this.$route.name == "studio-image")
            ) {
                return true;
            } else {
                return false;
            }
        }
    },
    methods: {
        makeRandom() {
            this.store.random = true;
            this.store.swipeImages = this.store.shuffledImages;
        },
        makeLinear() {
            this.store.random = false;
            this.store.swipeImages = this.store.orderedImages;
        }
    }
};
</script>

<style scoped>
#newMenu {
    position: fixed;
    top: 1rem;
    left: 1rem;
    z-index: 10;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    font-size: 1.25rem;
}

@media screen and (min-width: 768px) {
    #newMenu {
        flex-direction: row;
        font-size: 0.75rem;
        width: calc(100% - 2rem);
        justify-content: space-between;
    }
}

#mainMenu {
    margin-bottom: 1rem;
}

@media screen and (min-width: 768px) {
    #mainMenu {
        margin-bottom: 0rem;
        margin-right: 1rem;
    }
}

#mainMenu,
#subMenu {
    background-color: #292929;
    padding: 0.9rem 1rem;
    border-radius: 2rem;
    position: relative;
    display: flex;
    justify-content: space-between;
    box-shadow: 0 0 1rem 0rem rgba(0, 0, 0, 0.25);
}

@media screen and (min-width: 768px) {

    #mainMenu,
    #subMenu {
        padding: 0.7rem 1rem;
    }
}

#slideshow {
    width: 6.5rem;
    z-index: 1;
    text-align: center;
    margin: 0 1rem 0 0;
}

#index {
    width: 3.5rem;
    z-index: 1;
    text-align: center;
    margin: 0 1rem;
}

#about {
    width: 4.1rem;
    z-index: 1;
    text-align: center;
    margin: 0 0 0 1rem;
}

#shuffle {
    width: 4.4rem;
    z-index: 1;
    text-align: center;
    margin: 0 1rem 0 0;
}

#linear {
    width: 4.1rem;
    z-index: 1;
    text-align: center;
    margin: 0 0 0 1rem;
}

#text {
    width: 3.1rem;
    z-index: 1;
    text-align: center;
    margin: 0 1rem 0 0;
}

#image {
    width: 4.2rem;
    z-index: 1;
    text-align: center;
    margin: 0 0 0 1rem;
}

@media screen and (min-width: 768px) {
    #slideshow {
        width: 3.8rem;
    }

    #index {
        width: 2.2rem;
    }

    #about {
        width: 2.3rem;
    }

    #shuffle {
        width: 2.6rem;
    }

    #linear {
        width: 2.4rem;
    }

    #text {
        width: 1.7rem;
    }

    #image {
        width: 2.4rem;
    }
}

#mainMenu a,
#mainMenu span,
#subMenu a,
#subMenu span {
    color: #969696;
    text-decoration: none;
    transition: color 0.5s;
    z-index: 1;
    text-align: center;
}

#mainMenu>a:last-child,
#subMenu>a:last-child,
#subMenu>span:last-child {
    margin-right: 0;
}

#mainMenu a.active,
#subMenu a.active,
#subMenu span.active {
    color: black;
    font-family: "JMMP Medium";
    /* font-feature-settings: 'ss01' on; */
}

#marker,
#marker2 {
    position: absolute;
    left: 0;
    border-radius: 2rem;
    background-color: white;
    top: 0;
    color: white;
    transition: width 0.15s, left 0.15s;
    height: 1.4rem;
    width: 0;
    padding: 0;
}

#subMenu>div {
    transition: width 0.15s, left 0.15s;
}

@media screen and (min-width: 768px) {

    #marker,
    #marker2 {
        height: 0.3rem;
    }
}

#marker.Slideshow {
    width: 6.5rem;
    left: 0;
    padding: 1rem;
}

#marker.Index {
    width: 3.9rem;
    left: 8.3rem;
    padding: 1rem;
}

#marker.About {
    width: 4.1rem;
    left: 14rem;
    padding: 1rem;
}

#marker2.shuffle {
    width: 4.4rem;
    left: 0;
    padding: 1rem;
}

#marker2.linear {
    width: 4.1rem;
    left: 6.4rem;
    padding: 1rem;
}

#marker2.index {
    width: 3.1rem;
    left: 0;
    padding: 1rem;
}

#marker2.images {
    width: 4.2rem;
    left: 5.2rem;
    padding: 1rem;
}

@media screen and (min-width: 768px) {
    #marker.Slideshow {
        width: 3.8rem;
    }

    #marker.Index {
        width: 2.1rem;
        left: 5.9rem;
    }

    #marker.About {
        width: 2.3rem;
        left: 10rem;
    }

    #marker2.shuffle {
        width: 2.6rem;
    }

    #marker2.linear {
        width: 2.4rem;
        left: 4.6rem;
    }

    #marker2.index {
        width: 1.7rem;
    }

    #marker2.images {
        width: 2.4rem;
        left: 3.7rem;
    }
}

#shuffle,
#linear {
    cursor: pointer;
}
</style>
